import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from 'src/core/store/redux';

import CONFIG from '@config';
import { removeProfile } from '@modules/authentication/profileStore';
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Loading from '@shared/components/Loading';

import App from './App';

interface IPersistStore {
  remember?: boolean;
}

const PersistStore: React.FC<IPersistStore> = () => {
  const handleBeforeLift = () => {
    return new Promise<void>(resolve => {
      const timer = setTimeout(() => {
        store.dispatch(removeProfile());
        resolve();
      }, 3000);

      const persist = JSON.parse(window.localStorage.getItem(`persist:${CONFIG.APP_NAME}`) || '');
      const profile = JSON.parse(persist.profile) || {};
      if (profile.token != null && profile.token !== '') {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = CONFIG.LOGIN_PAGE;
        document.body.appendChild(iframe);
        const data = {
          message: 'checkLogin',
          data: {
            username: profile.user.username,
          },
        };
        iframe.onload = () => {
          iframe.contentWindow?.postMessage(data, '*');
        };
      } else {
        resolve();
        clearTimeout(timer);
      }
      window.addEventListener('message', e => {
        const data = e.data;
        if (data.message === 'recheckLogin') {
          if (data.data === 'success') {
            resolve();
            clearTimeout(timer);
          } else if (data.data === 'fail') {
            store.dispatch(removeProfile());
            resolve();
            clearTimeout(timer);
          }
        }
      });
    });
  };
  return (
    <PersistGate loading={<Loading />} persistor={persistor} onBeforeLift={handleBeforeLift}>
      <App />
    </PersistGate>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <Router>
    <Provider store={store}>
      <PersistStore remember={true} />
    </Provider>
  </Router>,
);
